import React, { useState } from "react";
import SheduleAppointment from "../NewAppointment/SheduleAppointment";
import InmateInfoForm from "../NewAppointment/InmateInfoForm";
import ConfirmAppointmentForm from "../NewAppointment/ConfirmAppointmentForm";
import FullPageLoader from "./FullPageLoader";

interface SteppersProps {
  currentAppointment: any | undefined,
  pageNumber: number | undefined,
  isReschedule: boolean
}

const Steppers: React.FC<SteppersProps | null> = (props) => {
  const [current, setCurrent] = useState(props?.pageNumber ?? 0);
  const [formData, setFormData] = useState({
    appointmenttypeid: "",
    appointmentdatetime: props?.currentAppointment?.appointmentdatetime ?? "",
    inmateFirstName: props?.currentAppointment?.inmateFirstName ?? "",
    inmateLastName: props?.currentAppointment?.inmateLastName ?? "",
    inmatedob: props?.currentAppointment?.inmatedob ?? "",
    heldforanothercounty: props?.currentAppointment?.countyid && props?.currentAppointment?.countyid !== 0 ? true : false,
    countyid: props?.currentAppointment?.countyid ?? 0,
    admincountyid: 0,
    medications: props?.currentAppointment?.medications ?? "",
    additionalinfo: props?.currentAppointment?.additionalinfo ?? "",
    created: new Date(),
    createdby: 0,
    appointmenttypename: "",
    countyname: props?.currentAppointment?.countyname ?? "",
    admincountyname: "",
    providername: props?.currentAppointment?.providerName ?? "",
    providerId: props?.currentAppointment?.providerId ?? "",
    isHeldFor: false,
    zipCode: props?.currentAppointment?.zipCode ?? "",
    facilityName: "",
    correctionalFacilityId: 0
  });
  const [primaryProviderMessage, setPrimaryProviderMessage] = useState("");
  const [convertedTime, setConvertedTime] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const updateFormData = (data: any) => {
    setFormData((prevData) => ({ ...prevData, ...data }));
  };

  const changeStep = (cur: number) => {
    setCurrent((c) => c + cur);
  };

  const newSteps = [
    {
      title: "Inmate Information",
      content: (
        <InmateInfoForm
          changeStep={changeStep}
          updateFormData={updateFormData}
          formData={formData}
        />
      ),
    },
    {
      title: props?.isReschedule ? "Reschedule an Appointment" : "Schedule an Appointment",
      content: (
        <SheduleAppointment
          changeStep={changeStep}
          updateFormData={updateFormData}
          formData={formData}
          setPrimaryProviderMessage={setPrimaryProviderMessage}
          setConvertedTime={setConvertedTime}
          setIsLoading={setIsLoading}
          isReschedule={props?.isReschedule ?? false}
          currentAppointment={props?.currentAppointment}
        />
      ),
    },

    {
      title: "Confirm Application",
      content: (
        <ConfirmAppointmentForm 
          changeStep={changeStep}
          formData={formData}
          primaryProviderMessage={primaryProviderMessage}
          convertedTime={convertedTime}
          isReschedule={props?.isReschedule ?? false}
          currentAppointment={props?.currentAppointment}
        />
      ),
    },
  ];

  return (
    <div>
      {isLoading && <FullPageLoader />}
      <div>{newSteps[current]?.content}</div>
    </div>
  );
};

export default Steppers;
